
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconLinkSelector = "fhi-icon-link";

@customElement(FhiIconLinkSelector)
export class FhiIconLink extends LitElement {
  @property({ type: String }) color: string = "currentcolor";

  @property({ type: Number }) size: number = 24;

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this.size}" height="${this.size}" fill="${this.color}"><path fill-rule="evenodd" d="M20.53 3.47c-2.15-2.15-5.541-2.293-7.841-.209l-.22.208-1.5 1.5a.75.75 0 0 0 1.061 1.06l1.5-1.5.163-.153c1.699-1.541 4.182-1.441 5.777.154l.15.157c1.45 1.598 1.495 3.975.004 5.62l-.154.162-2.5 2.5c-1.654 1.654-4.076 1.706-5.777.156l-.163-.156-.5-.5-.056-.05a.75.75 0 0 0-1.056 1.054l.052.057.5.5.219.209c2.29 2.082 5.62 2.012 7.841-.21l2.5-2.5.21-.218c2.016-2.226 1.947-5.474-.007-7.63zm-6.5 6.5c-2.221-2.221-5.551-2.29-7.842-.208l-.219.208-2.5 2.5c-2.299 2.3-2.218 5.841 0 8.06l.212.203c2.228 2.02 5.621 2.025 7.849-.203l1.5-1.5a.75.75 0 1 0-1.06-1.06l-1.5 1.5c-1.648 1.647-4.132 1.648-5.783.15l-.157-.15c-1.647-1.647-1.7-4.24 0-5.94l2.5-2.5.163-.155c1.702-1.55 4.123-1.498 5.777.155l.5.5.057.052a.75.75 0 0 0 1.055-1.056l-.052-.056z" clip-rule="evenodd"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
